export default __webpack_public_path__ + "static/media/document-logo-6-active.7697dc3a.svg";